// extracted by mini-css-extract-plugin
export default {"link":"bZdXF","labelEllipsis":"_1xI3c","roundedCorners":"_11Qj0"};